<template>
  <div class="preview-container" v-if="distribution && distribution.title">
    <div class="row">
      <div class="col-md-4">
        <div class="py-3">
          <div>
            <img :src="distribution.cover_image_small || distribution.cover_image" width="100%" />
          </div>
          <div class="text-center mt-2 text-white">
            <h2 class="title mt-3 mb-0">{{ distribution.title }}</h2>
            <p class="release-artist">{{ distribution.artist.name }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="py-3 songs-container">
          <div
            v-for="(song, index) in distribution.songs"
            v-bind:key="`song_${index}`"
            class="clearfix"
          >
            <div class="pull-left mt-1">
              <i class="fa fa-music text-white"></i>
            </div>
            <div class="pull-left ml-3">
              <div class="song-name" :style="`width: ${songWidth}px;`">{{ song.title }}<span v-if="song.featuring"> {{ getFeaturing(song) }}</span></div>
              <div class="artist-name">{{ song.artist || distribution.artist.name }}</div>
            </div>
            <div class="pull-right duration">{{ song.durationText }}</div>
          </div>
          <div class="copyright mt-4 ml-4">
            <div>&copy; {{ distribution.artist.legal_name }} {{ distribution.artist.legal_last_name || '' }}</div>
            <div v-if="distribution.copyright_holder">℗ {{ distribution.copyright_holder }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'

export default {
  name: 'DistributionPreview',
  props: ['distribution'],
  data: function () {
    return {
      songWidth: 100
    }
  },
  methods: {
    getFeaturing: function (song) {
      let featuring = ''
      if (song.featuring && typeof artist === 'string') {
        featuring = `(feat. ${song.featuring})`
      } else if (song.featuring) {
        featuring = `(feat. ${song.featuring.map(e => e.name).join(', ')})`
      }

      return featuring
    },
    parseTime: function () {
      _.each(this.distribution.songs, song => {
        if (song.duration) {
          let measuredTime = new Date(null)
          measuredTime.setSeconds(song.duration) // specify value of SECONDS
          song.durationText = measuredTime.toISOString().substr(14, 5)
        }
      })

      this.$forceUpdate()
    }
  },
  watch: {
    distribution: function () {
      this.parseTime()
    }
  },
  mounted: function () {
    this.parseTime()

    setTimeout(() => {
      this.songWidth = window.$('.songs-container').width() - 100
    })
  }
}
</script>
<style lang="scss" scoped>
.preview-container .row {
  border-radius: 3px;
  background: rgb(30, 42, 56);
  background: linear-gradient(
    147deg,
    rgba(30, 42, 56, 1) 0%,
    rgba(6, 8, 11, 1) 100%
  );
  // width: 600px;
}

.song-name {
  color: white;
  font-weight: 400;
  font-size: 18px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.artist-name,
.duration,
.release-artist,
.copyright {
  color: #bbb;
}

.copyright {
  font-size: 12px;
}

.title {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributionPreview.vue